import { CheckCircle2 } from "lucide-react";
import { ReportCard } from "./primitives/ReportCard";
import { groupPassedByPillar, flattenPassedTitles } from "./reportUtils";

// Paid report only: the measured checks the site already passes (backend sends
// passed_checks in the paid response only). Absent/empty -> no card.
//
// Flattened per lovable.dev mockup idea #3: one checklist of every passed
// title across all pillars, no pillar sub-headings and no "Alles bestanden"
// pillar badge — groupPassedByPillar is still used (for its pillar-order and
// dropped-empty-pillar rules), just flattened via flattenPassedTitles instead
// of rendered as separate per-pillar sections.
export default function PassedChecks({ data, L }) {
  const passed = data?.passed_checks;
  if (!Array.isArray(passed) || passed.length === 0) return null;
  const groups = groupPassedByPillar(passed, Object.keys(L.pillars), data.score_checks || {});
  if (groups.length === 0) return null;
  const titles = flattenPassedTitles(groups);
  return (
    <div data-testid="passed-checks">
      <ReportCard icon={<CheckCircle2 className="h-4 w-4" />} title={L.passedTitle} description={L.passedDesc}>
        <ul role="list" className="grid grid-cols-1 gap-x-6 gap-y-1.5 sm:grid-cols-2">
          {titles.map((t, i) => (
            <li key={i} className="flex items-start gap-2 text-base text-green-900">
              <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-green-600" aria-hidden="true" />
              <span>{t}</span>
            </li>
          ))}
        </ul>
      </ReportCard>
    </div>
  );
}
